import React, { Suspense, useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import "./scss/style.scss";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import "./app.css";
import AppWrapper from "./wrapper";

//TODO: Clean view folder

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

// Pages
const Login = React.lazy(() => import("./Pages/Auth/Login"));
const Register = React.lazy(() => import("./Pages/Auth/Register"));
const ForgotPassword = React.lazy(() => import("./Pages/Auth/forgotPassword"));
const CreateNewPassword = React.lazy(() =>
  import("./Pages/Auth/createNewPassword")
);
const Page404 = React.lazy(() => import("./Pages/common/Page404"));
const Page500 = React.lazy(() => import("./Pages/common/Page500"));

// Private routes
const PrivateRoutes = React.lazy(() => import("./layout/DefaultLayout"));

//Public routes
const PublicRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/login" />} />
      <Route path="/login" element={<Login />} />
      {/* <Route path="/register" name="Register Page" element={<Register />} /> */}
      <Route
        path="/create-new-password/:token"
        name="CreateNewPassword Page"
        element={<CreateNewPassword />}
      />
      <Route
        path="/forgot-password"
        name="ForgotPassword Page"
        element={<ForgotPassword />}
      />
      {/* if route exists in private then redirect to login else 404 */}
      <Route path="*" element={<Page404 />} />
    </Routes>
  );
};

const App = () => {
  const { userAuth } = useSelector(
    ({ persistedReducer }) => persistedReducer.getAuth
  );

  return (
    <BrowserRouter>
      <AppWrapper>
        <Suspense fallback={loading}>
          {userAuth?.user?.username ? <PrivateRoutes /> : <PublicRoutes />}
        </Suspense>
      </AppWrapper>
    </BrowserRouter>
  );
};

export default App;
